import gsap, { Expo, Back } from "gsap";
import { useEffect, useRef, useState } from "react";
import { Checkbox, Container } from "../../utils/CustomComponents";

function SignUp({ view_controller, setController }) {
    const h2 = useRef();
    const h3 = useRef();
    const selection = useRef();
    const button = useRef();
    const [TimeLine, setTimeLine] = useState(null);
    const [Method, setMethod] = useState("individual");


    useEffect(() => {
        const anim = gsap.timeline({ paused: true, reversed: true });
        anim.from([h2.current, button.current, h3.current, selection.current], {
            autoAlpha: 0,
            y: 100,
            stagger: { each: 0.125 },
            ease: Expo.easeOut,
            duration: 2,
        }).from(
            [...selection.current.children],
            {
                scale: 0.5,
                autoAlpha: 0,
                ease: Back.easeOut.config(2.5),
                stagger: { each: 0.25 },
                duration: 0.5,
            },
            "-=1.5"
        );
        anim.play();
        setTimeLine(anim);
    }, [view_controller]);
    
    return (
        <div className="sign_up">
            <Container>
                <form onSubmit={(e) => e.preventDefault()}>
                    <h2 ref={h2}>Create an Account</h2>
                    <h3 ref={h3}>Sign Up As</h3>
                    <div className="selection" ref={selection}>
                        <Checkbox
                            Checked={Method === "company"}
                            exe={() => {
                                setMethod("company");
                            }}
                            text="Company"
                            id="Company"
                            name="signUp"
                        />
                        <Checkbox
                            Checked={Method === "individual"}
                            exe={() => {
                                setMethod("individual");
                            }}
                            text="Individual"
                            name="signUp"
                            id="Individual"
                            type={"checkbox"}
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn_pry"
                        ref={button}
                        onClick={() => {
                            TimeLine.reverse(1.2);
                            setTimeout(() => {
                                Method === "company"
                                    ? setController("create_acc_comp")
                                    : setController("create_acc_ind");
                            }, 1500);
                        }}
                    >
                        Continue
                    </button>
                </form>
            </Container>
        </div>
    );
}

export default SignUp;
